import { usePresence } from '../hooks/usePresence';

export default function LiveViewers() {
  const count = usePresence();

  if (!count || count < 1) return null;

  return (
    <div
      title={`${count} ${count === 1 ? 'viewer' : 'viewers'} online`}
      className="fixed top-3 right-3 z-40 flex items-center gap-1.5 px-2 py-1 rounded-full shadow-md"
      style={{ background: "rgba(15,23,42,0.75)", backdropFilter: "blur(6px)", border: "1px solid rgba(255,255,255,0.08)" }}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-500" />
      </span>
      <span className="text-[10px] font-bold text-white leading-none">{count}</span>
    </div>
  );
}
